import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-tabs',
  templateUrl: './users-tabs.component.html',
  styleUrls: ['./users-tabs.component.scss']
})
export class UsersTabsComponent implements OnInit {
  tabs = [];
  showContentTab = true;
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.tabs = [];
    this.tabs.push({name: 'admins',  label: 'Usuarios Administrativos', route: 'admins'});
    this.tabs.push({name: 'program',  label: 'Usuarios de Programa',  route: 'program'});
  }

  ngOnInit() {

  }
  
  onTabChange(tab) {  
    console.log(tab);  
    this.router.navigate([tab.addedItems[0].route], {
      relativeTo: this.route
    });
  }
  get tabIndex() {
    return this.router.url.endsWith('program') ? 1 : 0;
  }

}
